import { render, staticRenderFns } from "./DisplayTextField.vue?vue&type=template&id=26fb2757"
import script from "./DisplayTextField.vue?vue&type=script&lang=js"
export * from "./DisplayTextField.vue?vue&type=script&lang=js"
import style0 from "./DisplayTextField.vue?vue&type=style&index=0&id=26fb2757&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports